import { render, staticRenderFns } from "./MarketAreaTabTable.vue?vue&type=template&id=94559c48&scoped=true"
import script from "./MarketAreaTabTable.vue?vue&type=script&lang=js"
export * from "./MarketAreaTabTable.vue?vue&type=script&lang=js"
import style0 from "./MarketAreaTabTable.vue?vue&type=style&index=0&id=94559c48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94559c48",
  null
  
)

export default component.exports